<div class="app-container">
  <page-header [icon]="'far-envelope'" [title]="'companyCarriers'">
    <ng-container class="header-button">
      @if (canCreate) {
        <btn
          [routerLink]="['/company-carrier']"
          [classes]="['btn-first', 'float-right']"
          [icon]="'far-plus'"
          [label]="'companyCarrier.create'"
          [title]="'companyCarrier.create' | translate"
          [dataCyAttribute]="'go-carrier'"
        ></btn>
      }
    </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form
      [filters]="queryFilters()"
      [filtersForExport]="queryFilters()"
      [entity]="'company-carriers'"
      (onSubmit)="queryCompanyCarriers.refetch()"
      (onClearClick)="clearFilters()"
      [isFilterInvisible]="true"
      [areExportsInFilter]="false"
      [totalItems]="totalItems()"
    >
      <form-row-select
        [label]="'carrier'"
        [icon]="'far-list'"
        [model]="filters().carrier"
        [options]="queryCarriers.data()"
        (modelChange)="updateFilterCarrier($event)"
        [dataCyAttribute]="'carrier-name-filter'"
      ></form-row-select>
    </app-filter-form>

    <app-base-listing
      [listName]="'companyCarriers'"
      [query]="queryCompanyCarriers"
      [columns]="listingColumns"
      [selectedColumns]="listingColumns"
      [sortProp]="sortProp"
      [sortDir]="sortDir"
    ></app-base-listing>
  </section>
</div>
